module.exports = __webpack_public_path__ + "static/img/title-1.0ff9af01.svg";